import { Link } from "react-router-dom";
import React from "react";
import SEO from "../Components/seo";

const About = () => {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Vincosys",
    "description": "Vincosys specializes in transforming ideas into impactful digital solutions with IoT, mobile, and web development services.",
    "url": window.location.href,
    "publisher": {
      "@type": "Organization",
      "name": "Vincosys",
      "logo": {
        "@type": "ImageObject",
        "url": "assets/Images/vincosys.png" 
      },
      "description": "Empowering innovation in the digital era",
  
      "foundingDate": "2015", 
      "numberOfEmployees": "30+",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "#58-12-13/1,Sanjeevanagar",
        "addressLocality": "Rajahmundry",
        "addressRegion": "Andhra pradesh",
        "postalCode": "533105",
        "addressCountry": "India"
      }
    }
  };
  
  
  return (
    <div className="container">
      <SEO
        title="Vincosys | IoT & Software Development Company | Custom Smart Solutions & Software solutions "
        description="Vincosys specializes in transforming ideas into impactful digital solutions with IoT, mobile, and web development services."
        keywords="digital solutions, IoT, web development, mobile development, tech innovation"
        ogTitle="About Vincosys - Digital Innovation Experts"
        ogDescription="Learn how Vincosys drives business growth through cutting-edge technology and tailored services."
        ogImage="assets/Images/resource/v_img.jpg" // Replace with your actual image
        ogUrl={window.location.href}
      >
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
      </SEO>

      <div className="about-section">
        <div className="auto-container">
          <div className="sec-title">
            <div className="title">ABOUT COMPANY</div>
            <h2>
              Empowering Innovation in <br />
              the Digital Era.
            </h2>
          </div>
          <div class="row clearfix">
            <div class="content-column col-lg-6 col-md-12 col-sm-12">
              <div class="inner-column">
                <div class="text">
                  At Vincosys, we specialize in transforming ideas into
                  impactful digital solutions. From IoT solutions to mobile and
                  web development, our team of experts drives business growth
                  through cutting-edge technology, tailored services, and a
                  commitment to excellence. We help businesses thrive in today’s
                  dynamic tech landscape.
                  {/* <ul>
                    <li>Commitment to Quality</li>
                    <li>Future-Focused Solutions</li>
                  </ul> */}
                </div>
              

                <Link
                  to="/AboutUs"
                  class="lightbox-image theme-btn btn-style-one"
                >
                  <span class="txt">Read More</span>
                </Link>
              </div>
            </div>

            {/* <!-- Images Column --> */}
            <div class="images-column col-lg-6 col-md-12 col-sm-12">
              <div class="inner-column">
                <div class="main">
                  <div class="pattern-layer"></div>
                </div>
                <div class="images-outer parallax-scene-1">
                  <div class="image" data-depth="0.10">
                    <img
                      src="../../assets/Images/resource/about-1.jpg"
                      alt=""
                    />
                  </div>
                  <div class="image-two" data-depth="0.30">
                    <img
                      src="../../assets/Images/resource/about-2.jpg"
                      alt=""
                    />
                  </div>
                  <div class="image-three" data-depth="0.20">
                    <img
                      src="../../assets/Images/resource/about-3.jpg"
                      alt=""
                    />
                  </div>
                  <div class="image-four" data-depth="0.30">
                    <img
                      src="I../../assets/Images/resource/about-4.jpg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};
export default About;
